const e = Object.freeze({
  key: Symbol("MODULE_INJECTION_KEY"),
  defaults: {
    variant: void 0
  }
});
export {
  e as M
};
//# sourceMappingURL=Module.keys-CEsrW2f0.js.map
